import React, { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button, Image } from 'react-bootstrap';
import news from "../../actions/news";
import moment from 'moment';

export default function ArticleDetail() {
   const navigate = useNavigate();
   const { id } = useParams();
   const [newsData, setNewsData] = useState([]);
   const [filter, setFilter] = useState({
      limit:"",
      filter:""
   });

  useEffect(() => {
   news.actions.get_news_detail(id).then((res)=>{
      setNewsData(res?.data)
   });
  },[])

  return (
   <div className="bg-light vh-100">
      <div className="fixed-top header bg-light">
         <div className="text-center fw-semibold">
            Detail
         </div>
         <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => navigate(-1)}>
               <i className="ph-arrow-left text-light"></i>
         </Button>
      </div>

      <div className="p-4 mt-5">
         <Image src={newsData?.image} height="200px" width="100%" className="mt-5" style={{objectFit:'cover',borderRadius:'10px'}}/>
         <div className="text-end">
            <small className="mt-2 mb-3 text-secondary" style={{fontSize: '12px'}}>
               By {newsData?.author?.name}
               <span className="ms-2 text-secondary">{moment(new Date(newsData?.created_at)).format('DD/MM/YYYY')}</span> 
            </small>
         </div>
         <h4 className="fw-bold mt-3 mb-2 text-dark">{newsData?.title}</h4>
         <small className="wrap-text" dangerouslySetInnerHTML={{ __html: newsData?.body }} />
      </div>
   </div>
  );
}